module.exports = __webpack_public_path__ + "img/icon-search.cc9408f.svg";